import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api";

/**
 * POSTs /api/v1/auth/logout/ — ends the session and clears the
 * React Query cache so the next ["me"] read returns null.
 */
export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await api.post("/auth/logout/");
    },
    onSuccess: () => {
      qc.setQueryData(["me"], null);
      // Drop everything else too — different user might sign in next.
      qc.clear();
    },
  });
}
